import React from 'react';
import PropTypes from 'prop-types';
//import { Box, Typography } from '@material-ui/core';
// import { useStyles } from "./styles";
//import ScrollableTabs from '../../../../../../components/TabPanel/index';
import ScrollableTabs from '../../../components/TabPanel/index';
/*import { 
    triggerStockAPI,
    triggerStockCsvAPI
} from '../../../../../../redux/actions/index';*/

import { 
    triggerStockAPI,
    triggerStockCsvAPI
} from '../../../redux/actions/index';

export default function DeviceStock(props) {
  
  const { stockModel: { secTilesMasterTxDtos: tilesDto = [], isSectionActive = '', sectionName }, ...other } = props;
  if(isSectionActive === "Y") {
    if(tilesDto.length) {
      return (
        <div data-cy="stock-section">
          <ScrollableTabs 
            sectionHeader={sectionName} 
            section={sectionName}
            tabsDto={tilesDto} 
            sortingProperty='tileId' 
            sortingOrder='asc'
            tabVariant='fullWidth'
            color= '#9cf26e'
            triggerStockAPI={triggerStockAPI}
            triggerStockCsvAPI={triggerStockCsvAPI}
            {...other}
          />
        </div>
      );
    }
    else {
      return null
    }
  }
  else {
    return null
  }
}

DeviceStock.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any
    })
  )
}